import React, { useState } from 'react';
import { Checkbox } from '@mui/material';

const useComponent = (userAttendance, setUserAttendance, initialAttendanceState, editing) => {
  const thereIsComponent = (data, index) => {
    const userId = data[5];
    const lessonIndex = data[7];
    const initialState = initialAttendanceState !== undefined ? initialAttendanceState[lessonIndex]?.attended : false;
    const [isPresent, setIsPresent] = useState(data[4]);

    const handleChange = event => {
      if (event.target.checked === true) {
        setIsPresent(true);

        if (!initialState) {
          setUserAttendance([...userAttendance, { id: userId, attended: true, lessonIndex }]);

          return;
        }
        setUserAttendance(userAttendance.filter(x => x.id !== userId));
      } else {
        setIsPresent(false);

        if (initialState) {
          setUserAttendance([...userAttendance, { id: userId, attended: false, lessonIndex }]);

          return;
        }
        setUserAttendance(userAttendance.filter(x => x.id !== userId));
      }
    };

    if (index === 4) {
      return <Checkbox checked={isPresent} onChange={handleChange} disabled={!editing} />;
    }
    return data[index];
  };

  return { thereIsComponent };
};

export default useComponent;
